import React from 'react';
import { Input } from 'antd';
import { track } from '$lib/tracking';

const handleCopyCode = () => {
  /* eslint-disable no-alert */

  const copyTextarea = document.querySelector('[data-aaa=referralCode]');
  copyTextarea.focus();
  copyTextarea.select();

  try {
    const successful = document.execCommand('copy');
    if (successful) {
      alert('Copied'); // eslint-disable-line no-alert
    } else {
      alert(
        "We couldn't copy automatically for some reason, but you can still manually copy/paste"
      );
    }
  } catch (err) {
    alert(
      "We couldn't copy automatically for some reason, but you can still manually copy/paste"
    );
  }

  track('Individual referral | Copied');
};

const ReferInput = ({ currentUser }) => {
  const { referralCode } = currentUser;
  return (
    <Input.Search
      data-aaa="referralCode"
      placeholder="input search text"
      onSearch={handleCopyCode}
      value={`https://achievable.me/#a_aid=R-${referralCode}`}
      enterButton={<i className="fad fa-copy" />}
    />
  );
};

export default ReferInput;
